import React, { FC } from "react";
import { Button, DeleteIcon, DownloadIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import { usePermissions } from "~/shared/context/PermissionContext";

import TransferSelectedIcon from "./icons/TransferSelectedIcon";

import s from "~/pages/BaseStaff/BaseStaff.less";

interface IBaseStaffBulkActionsProps {
  onDownload: () => void;
  onTransfer: () => void;
  onDismiss: () => void;
  hasSelectedRows: boolean;
}

const BaseStaffBulkActions: FC<IBaseStaffBulkActionsProps> = ({
  onDownload,
  onTransfer,
  onDismiss,
  hasSelectedRows,
}) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();

  return (
    <div className={s.tableToolbar}>
      {hasPermission("employeeAccounting.employee.report.get") && (
        <Button
          bold
          color="secondary"
          variant={"filled"}
          icon={<DownloadIcon size={12} fill="#495a64" />}
          onClick={onDownload}
          radius={30}
          size="medium"
        >
          {t("directory.download")}
        </Button>
      )}
      {/* TODO PASDILER-2428: массовое увольнение и смена ДЦ временно скрыты до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
      {hasSelectedRows && (
        <div className={s.tableToolbarGroup}>
          <Button
            bold
            color="secondary"
            variant={"filled"}
            onClick={onDismiss}
            radius={30}
            size="medium"
          >
            {t("employee.dismissSelected")}
          </Button>
          <Button
            bold
            color="secondary"
            icon={<TransferSelectedIcon size={12} fill="#ffffff" />}
            onClick={onTransfer}
            radius={30}
            size="medium"
          >
            {t("employee.transferSelected")}
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default BaseStaffBulkActions;
